<!-- head-line -->
<template>
  <div class="top-line">
    <div class="main-title">{{title}}</div>
    <div class="menu">
      <p v-for="(item, index) in menu" :key="index" :class="selectIndex === index ? 'select' : ''" @click="select(index)">{{item}}</p>
    </div>
    <div class="media">
      <ul>
        <li v-for="(item, index) in mediaList" :key="index">
          <a :href="item.link" target="_blank">
            <img :src="item.img" alt="">
          </a>
        </li>
      </ul>
    </div>
    <div class="app-menu">
      <div class="iconfont icon-caidan m-menu" @click="show" v-show="!showNav"></div>
      <div class="iconfont icon-quxiao cancel" @click="hide" v-show="showNav"></div>
    </div>
    <transition name="slide">
      <div class="nav" v-show="showNav">
        <ul class="menuList">
          <li v-for="(item, index) in menu" :key="index" :class="selectIndex === index ? 'select' : ''" @click="select(index)">{{item}}</li>
        </ul>
        <ul class="mediaList">
          <li v-for="(item, index) in mediaList" :key="index">
            <a :href="item.link" target="_blank">
              <img :src="item.img" alt="">
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    menu: {
      type: Array,
      default: () => []
    },
    mediaList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectIndex: 0,
      showNav: false
    }
  },
  mounted () {
    let index = parseInt(localStorage.getItem('index'))
    if (!index) {
      index = 0
    }
    this.$nextTick(() => {
      this.select(index)
    })
  },
  methods: {
    select (index) {
      this.selectIndex = index
      localStorage.setItem('index', index)
      this.showNav = false
      this.$emit('select', index)
    },
    show () {
      this.showNav = true
    },
    hide () {
      this.showNav = false
    },
  }
}

</script>
<style lang='scss' rel='stylesheet/scss' scoped>
@import '../style/common.scss';
@media screen and (max-width: 926px) {
  body{
    .top-line{
      .menu{
        display: none;
      }
      .media{
        display:none;
      }
      .app-menu {
        display:block;
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  body {
    .top-line{
      .menu{
        display: flex;
      }
      .media{
        display:block;
      }
      .app-menu {
        display:none;
      }
    }
  }
}
.select {
  color: $thema;
}
.menuList{
  font-size:25px;
  li{
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
  }
  border-bottom: 1px solid gray;
}
.mediaList{
  display:flex;
  justify-content: center;
  align-items: center;
  padding:10px;
  box-sizing: border-box;
  background-color: black;
  li{
    width: 54px;
    margin:0 10px;
    a{
      display: block;
      width:100%;
      img{
        width:100%;
      }
    }
  }
}
.m-menu,.cancel{
  color: $thema;
  line-height: 74px;
  font-size: 40px;
}
.cancel {
  font-size:60px;
}
.app-menu{
  display: none;
}
.nav{
  position:fixed;
  top: 80px;
  right:0;
  width:100%;
  background-color: #fff;
  z-index:999;
}
.top-line{
  position:fixed;
  left:0;
  top:0;
  z-index: 999;
  padding: 0 30px;
  box-sizing: border-box;
  background-color: black;
  height: 80px;
  width: 101%;
  display: flex;
  justify-content: space-between;
  .main-title{
    color: $thema;
    font-size: 30px;
    line-height: 80px;
  }
  .menu{
    height:100%;
    display:flex;
    align-items: center;
    color:white;
    font-size: 20px;
    justify-content: space-around;
    flex:1;
    P{
      cursor: pointer;
    }
  }
  .media{
    width:200px;
    height:100%;
    ul{
      width:100%;
      height:100%;
      display: flex;
      justify-content: center;
      align-items: center;
      li{
        margin: 0 10px;
        img{
          width:24px;
        }
      }
    }
  }
}
.slide-enter-active, .slide-leave-active {
  transition: all .5s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}
</style>